import Cancel from '../components/cancel/cancel'
import Reverser from '../components/reverser/reverser'
import Transfer from '../components/transfer/transfer'
import Confirmed from '../components/confirmed/confirmed'
import Rollback from '../components/rollback/rollback'
import RollbackFromDelayed from '../components/rollback-from-delayed/rollback'
import Absent from '../components/absent/absent'
import Delayed from '../components/delayed/delayed'
import InAttendance from '../components/in-attendance/in-attendance'
import Present from '../components/present/present'

export default {
  Cancel,
  Reverser,
  Transfer,
  Confirmed,
  Rollback,
  Absent,
  Delayed,
  RollbackFromDelayed,
  InAttendance,
  Present
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/components.js